module.exports = __webpack_public_path__ + "static/media/RP-43.399023f5.pdf";